<div class="palette-background-color-light-grey">
    <app-header></app-header>
    <ng-content></ng-content>
    <br>
    <app-footer></app-footer>
</div>
